const allrec = { data: [], loading: true, cache: {} };
const alltags = { data: [], loading: true };

export const GetAllExpenseVoucherRed = (state = allrec, action) => {
  switch (action.type) {
    case "get_expensevoucher":
      return {
        ...state,
        data: action?.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };

    case "clear_expensevoucher_cache":
      return {
        ...state,
        cache: {},
      };

    default:
      return state;
  }
};

export const GetExpTagsRed = (state = alltags, action) => {
  switch (action.type) {
    case "get_alltags":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetExpenseTagsRed = (state = alltags, action) => {
  switch (action.type) {
    case "get_allexpensetags":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
